__turbopack_context__.v({
  "maxWidthContainer": "_5aPLNa_maxWidthContainer",
  "sectionContainer": "_5aPLNa_sectionContainer",
  "sectionContent": "_5aPLNa_sectionContent",
  "sectionTitle": "_5aPLNa_sectionTitle",
});
